import { __rest } from "tslib";
import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "../../lib/utils";
function getRootSize(size) {
    switch (size) {
        case "small":
            return "h-4 w-8";
        default:
            return "h-6 w-11";
    }
}
function getThumbSize(size) {
    switch (size) {
        case "small":
            return "h-3 w-3 data-[state=checked]:translate-x-4";
        default:
            return "h-5 w-5 data-[state=checked]:translate-x-5";
    }
}
/**
 * @example
 *
 * ```jsx
 * import { Switch, Label } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <div className="flex items-center space-x-2">
 *       <Switch id="airplane-mode" />
 *       <Label htmlFor="airplane-mode">Airplane Mode</Label>
 *     </div>
 *   )
 * }
 * ```
 */
const Switch = React.forwardRef((_a, ref) => {
    var { className, size = "medium" } = _a, props = __rest(_a, ["className", "size"]);
    return (React.createElement(SwitchPrimitives.Root, Object.assign({ className: cn("peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-skvegreen-400 data-[state=unchecked]:bg-gray-300", getRootSize(size), className) }, props, { ref: ref }),
        React.createElement(SwitchPrimitives.Thumb, { className: cn("pointer-events-none block rounded-full shadow-lg ring-0 bg-white transition-transform data-[state=unchecked]:translate-x-0", getThumbSize(size)) })));
});
Switch.displayName = SwitchPrimitives.Root.displayName;
export { Switch };
//# sourceMappingURL=switch.js.map